import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const run = async () => {
            const hash = window.location.hash || "";
            const match = hash.match(/session_id=([^&]+)/);
            if (!match) {
                navigate("/", { replace: true });
                return;
            }
            const session_id = decodeURIComponent(match[1]);
            try {
                const me = await api.exchangeSession(session_id);
                setUser(me);
                // Clean the hash from the URL
                window.history.replaceState(null, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: me } });
            } catch (e) {
                console.error("session exchange failed", e);
                navigate("/", { replace: true });
            }
        };
        run();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
            <div className="overline">▍ Establishing session…</div>
        </div>
    );
}
